/**
 * /signup is retired: Bearri is invite-only. Anyone arriving there goes to the waitlist, keeping the plan they were
 * looking at (?plan=, or the older ?next=/app/plan?choose=<plan> pricing links). An invite ticket on an old-style
 * /signup link goes on to /invite untouched, so no invite breaks.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { planFromSearch } from '../../services/waitlistService';

export const TICKET_PARAMS = ['__clerk_ticket', '__clerk_invitation_token'] as const;

export function signupRedirectTarget(search: string, hash = ''): string {
  const qs = new URLSearchParams(search);
  if (TICKET_PARAMS.some((p) => qs.get(p))) return `/invite${search}${hash}`;
  let plan = planFromSearch(search);
  if (!plan) {
    const next = qs.get('next');
    if (next && next.startsWith('/') && !next.startsWith('//')) {
      try {
        const choose = new URL(next, 'https://bearri.co').searchParams.get('choose') ?? '';
        plan = planFromSearch(`?plan=${encodeURIComponent(choose)}`);
      } catch {
        plan = undefined;
      }
    }
  }
  return plan ? `/waitlist?plan=${plan}` : '/waitlist';
}

const SignupRedirect: React.FC = () => {
  const { search, hash } = useLocation();
  return <Navigate to={signupRedirectTarget(search, hash)} replace />;
};

export default SignupRedirect;
